<fury-page-layout mode="card">
    <fury-page-layout-header>
      <fury-breadcrumbs [@fadeInRight]  current={{filterValue}}></fury-breadcrumbs>
    </fury-page-layout-header>
  
    <fury-page-layout-content [@fadeInUp]>
      <fury-list name={{filterValue}} [columns]="columns" (filterChange)="onFilterChange($event)">
        <table [dataSource]="dataSource" mat-table matSort>
            <!-- actions Column -->
            <ng-container matColumnDef="actions">
                <th *matHeaderCellDef class="actions-cell" mat-header-cell mat-sort-header>Actions</th>
                <td *matCellDef="let row;let i=index" class="actions-cell" mat-cell>
                    <button type="button" [matMenuTriggerFor]="actionsMenu" (click)="$event.stopPropagation()"
                        mat-icon-button>
                        <mat-icon>more_horiz</mat-icon>
                    </button>
  
                    <mat-menu #actionsMenu="matMenu" yPosition="below" xPosition="before">
                        <button mat-menu-item [routerLink]="['/settings/lead-message/edit-lead-message/'+row?.value]">
                            <span>Edit</span>
                        </button>
                    </mat-menu>
                </td>
            </ng-container>

            <ng-container matColumnDef="pageName">
              <th mat-header-cell *matHeaderCellDef>Page Name</th>
              <td mat-cell *matCellDef="let element">
                {{(element?.pageName).split('-')[0] | titlecase}}
              </td>
            </ng-container>
  
  
          <tr *matHeaderRowDef="visibleColumns" mat-header-row></tr>
          <tr *matRowDef="let row; columns: visibleColumns;" class="clickable route-animations-elements" mat-row></tr>
        </table>
  
      </fury-list>
  
    </fury-page-layout-content>
  </fury-page-layout>
  


